import './mentions.css';

function Mentions() {
    return(
        <section id="legal-notice" className="legal-notice-section">
            <h2>Mentions Légales</h2>
            <p><strong>Éditeur du Site :</strong> Ludmilla Marti</p>
            <p><strong>Adresse :</strong> 22 720 Plésidy - Bretagne - FRANCE</p>
            <p><strong>Téléphone :</strong> +33 7 64 00 65 31</p>
            <p><strong>Email :</strong> <a href="mailto:armorwebcreations@gmail.com">armorwebcreations@gmail.com</a></p>
            <p><strong>Directeur de la publication :</strong> Ludmilla Marti</p>
            <p><strong>Hébergement :</strong> Vercel, https://vercel.com </p>
            <p><strong>Numéro de siret: </strong>93256032900017</p>
        </section>
    )
}
export default Mentions;